import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Link } from 'shared/components/Link';
import Modal from 'shared/components/Modal';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { Investment_IdeaType } from 'types/common';
import { actions } from 'actions';
import { selector } from './selector';

import './index.scss';

import * as iconSuccess from './static/img/success.svg';
import { Stocks_StockType } from '../../../__generated__/globalTypes';

interface Props {}

type Enhanced = Props &
  InjectedTranslateProps &
  ReturnType<typeof selector> &
  typeof mapDispatchToProps;

const b = b_.with('order-submitted-modal');

const mapDispatchToProps = {
  close: actions.hideOrderSubmittedModal,
};

const enhance = compose<Enhanced, Props>(translate, connect(selector, mapDispatchToProps));

class OrderSubmittedModal extends React.Component<Enhanced> {
  render() {
    const { t, close } = this.props;
    return (
      <Modal className={b()} onClose={close} data-testid="order-submit-success-modal">
        <div className={b('content')}>
          <img src={iconSuccess} className={b('image')} alt="" />
          <h2 className={b('title')}>{t('Order received')}</h2>
          <p className={b('message')}>{this._getMessage()}</p>
          <Link className={b('link')} to="/investments/open-investment" onClick={close}>
            {t('Go to my orders and investments')}
          </Link>
        </div>
      </Modal>
    );
  }

  _getMessage() {
    const { t, productType } = this.props;

    if (
      productType === Investment_IdeaType.BUY_AND_HOLD ||
      productType === Stocks_StockType.STOCKS ||
      productType === Stocks_StockType.ETF
    ) {
      return t('Order will be filled soon');
    }

    return t('Success request message');
  }
}

export default enhance(OrderSubmittedModal);
